import { SoundConstant, SoundConstant as SoundConstantBehavior } from "@quest/murka-games-behavior-panther/dist";

export class SoundConstantGame extends SoundConstantBehavior {
  public static BONUS_SYMBOL_TRIGGERING_ANIM_SOUND: string = "bonus_occur";
  public static TRANSITION_SCREEN_SOUND: string = "screen_change";
  public static SYMBOLS_STACK_WIN_SOUND: string = "character_win";
  public static RED_TRAIL_SOUND: string = "bonus_fly_to_golem_1";
  public static BLUE_TRAIL_SOUND: string = "bonus_fly_to_golem_2";
  public static GREEN_TRAIL_SOUND: string = "bonus_fly_to_golem_3";
  public static RED_CHARACTER_WIN_SOUND: string = "golem_blue_win";
  public static BLUE_CHARACTER_WIN_SOUND: string = "golem_blue_win";
  public static GREEN_CHARACTER_WIN_SOUND: string = "golem_green_win";
  public static WILD_DROP_SOUND_FREEGAME: string = "wild_drop_1";
  public static WILD_DROP_SOUND: string = "wild_drop_2";
  public static WILD_WIN_SOUND: string = "wild_win";
  //hold and respin feature
  public static BONUS_INTRO_SOUND: string = "bg_start_popup";
  public static BONUS_BGM: string = "music_ll";
  public static RED_ICON_DROP: string = "bonus_drop_1";
  public static BLUE_ICON_DROP: string = "bonus_drop_2";
  public static GREEN_ICON_DROP: string = "bonus_drop_3";
  public static TRAIL_ADD_SOUND: string = "golem_add";
  public static BONUS_OUTRO_SOUND: string = "bg_you_won";
  public static RESPIN_COUNT_DOWN_1: string = "respin_count_down_1";
  public static RESPIN_COUNT_DOWN_2: string = "respin_count_down_2";
  public static RESPIN_COUNT_DOWN_3: string = "respin_count_down_3";
  public static MULTIPLER_LOOP_SOUND: string = "apply_mult_to_coin";
  public static JP_WON_OUTRO_GRAND: string = "jackpot_popup_grand";
  public static JP_WON_OUTRO_MAJOR: string = "jackpot_popup_major";
  public static JP_WON_OUTRO_MINOR: string = "jackpot_popup_minor";
  public static JP_WON_OUTRO_MINI: string = "jackpot_popup_mini";
  public static GREEN_COLLECT_ALL_SOUND: string = "prizes_to_awardAll";
  public static WIN_COLLECTION_SOUND_1: string = "coin_to_winPlate_1";
  //freegame sound
  public static STICKY_SYMBOL_SOUND: string = "fs_sticky_frame";
}

SoundConstant.WIN_SOUND_FG_3 = "fs_custom_win";
SoundConstant.RETRIGGER_POP_UP_SOUND = "fs_additional";
SoundConstant.BIG_WIN_LOOP = "big_win_slot";
SoundConstant.SCATTER_LANDING = "fs_drop_";
